var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50121 5.86788V6.36788H8.50121V5.86788H7.50121ZM8.50121 5.86077V5.36077H7.50121V5.86077H8.50121ZM8.50121 10.4901V7.64566H7.50121V10.4901H8.50121ZM8.50121 5.86788V5.86077H7.50121V5.86788H8.50121ZM6.93455 8.50121H8.54028V7.50121H6.93455V8.50121ZM6.93455 10.6345H9.06788V9.63455H6.93455V10.6345ZM8.00122 3.52344C10.4742 3.52344 12.479 5.52821 12.479 8.00121H13.479C13.479 4.97592 11.0265 2.52344 8.00122 2.52344V3.52344ZM3.52344 8.00121C3.52344 5.52821 5.52821 3.52344 8.00122 3.52344V2.52344C4.97592 2.52344 2.52344 4.97592 2.52344 8.00121H3.52344ZM8.00121 12.479C5.52821 12.479 3.52344 10.4742 3.52344 8.00121H2.52344C2.52344 11.0265 4.97592 13.479 8.00121 13.479V12.479ZM8.00121 13.479C11.0265 13.479 13.479 11.0265 13.479 8.00121H12.479C12.479 10.4742 10.4742 12.479 8.00121 12.479V13.479Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInfo);
export default __webpack_public_path__ + "static/media/IconsInfo.f8e7e271637604807585bc4ad9a77d8b.svg";
export { ForwardRef as ReactComponent };